<template>
  <div class="interests-wrap">
    <div class="content">
      <van-swipe
        @change="onChange"
        class="box"
        :show-indicators="false"
        indicator-color="white"
        :loop="false"
        :initial-swipe="current"
      >
        <van-swipe-item
          class="interets"
          v-for="(item, index) in carList"
          :key="index"
        >
          <img
            src="@/assets/img/tag.png"
            class="tag"
          >
          <div class="car">{{ item.carNo }}</div>
          <div class="carNumber">车架号：{{ item.vinNo }}</div>
          <img
            src="@/assets/img/icon_edit.png"
            class="edit_img"
            @click="editCarInfo(item)"
          >
          <div
            class="num"
            v-if="carList.length > 1"
          >
            <div class="currPage">{{ swiperCurrent }}</div>
            <div class="total">{{ "/" + carList.length }}</div>
          </div>
        </van-swipe-item>
      </van-swipe>

      <div
        class="discount-box"
        v-if="discountUrl"
      >
        <img
          src="@/assets/img/discount/boci_car_discounts_banner.png"
          class="discount-img"
          @click="openWindow"
        >
      </div>

      <van-loading
        type="spinner"
        size="24px"
        class="loading"
        v-if="loadingBox"
      />
      <div
        class="carVip"
        :class="{ isCanLogin: isCanLogin }"
        v-if="serviceGroups.length > 0 && !loadingBox"
      >
        <div
          class="lrc"
          v-for="(group, idx) in serviceGroups"
          :key="idx"
        >
          <div class="carTop">
            {{
              group.serviceTypeName +
                "权益" +
                "（" +
                group.rightTotalValidCount +
                "次）"
            }}
          </div>
          <template v-for="(item, index) in group.serviceDetails">
            <div
              class="listBox"
              :key="index"
              v-if="!['FL10000009'].includes(item.productType)"
            >
              <div class="boxLeft">
                <div class="interests-name">
                  {{ item.vasItemName }}
                </div>
                <div class="interests-data">
                  有效期：{{ dateTransform(item.vasEffectiveDate) }}-{{
                    dateTransform(item.vasExpirationDate)
                  }}
                </div>
              </div>
              <div class="boxRight">
                <template
                  v-if="
                    group.needPushWarning || item.productType in productTypeMap
                  "
                >
                  <div
                    class="boxRight-botton"
                    v-if="group.needPushWarning"
                    @click="clickTips"
                  >
                    <span
                      style="
                        height: 24px;
                        line-height: 24px;
                        color: #fff;
                        font-size: 12px;
                      "
                    >立即使用</span>
                  </div>
                  <div
                    class="boxRight-botton"
                    v-else
                    @click="goToUserAgreement(item)"
                  >
                    <span
                      style="
                        height: 24px;
                        line-height: 24px;
                        color: #fff;
                        font-size: 12px;
                      "
                    >立即使用</span>
                  </div>
                </template>
                <template v-else>
                  <div class="boxRight-botton">
                    <wx-open-launch-weapp
                      id="launch-btn"
                      username="gh_3e83e978db70"
                      :path="item.path"
                    >
                      <script type="text/wxtag-template">
                        <span
                        style="display:block;width:48px;height:24px;line-height:24px;color:#fff;font-size:12px;">立即使用</span>
                      </script>
                    </wx-open-launch-weapp>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </div>
      </div>

      <div
        class="complete"
        v-if="serviceGroups.length == 0"
      >
        <img
          src="@/assets/img/icon_blank_default.png"
          class="imgBig"
        >
        <div class="carNot">车辆暂无可用权益</div>
      </div>

      <div class="button">
        <div
          @click="addListing"
          v-show="loadingList"
        >添加新车辆</div>
        <div @click="logout">退出登录</div>
      </div>

      <div
        class="go-home"
        v-if="isShowGoHomePage"
      >
        <img
          src="@/assets/img/icon_go_home.png"
          class="img"
          @click.stop="goHomePage"
        >
      </div>

    </div>

    <van-dialog
      v-model="isShowTips"
      title="客户信息授权"
      :show-cancel-button="false"
      confirm-button-text="我同意"
    >
      <div class="dialog-wrap">
        <p>
          本服务由中保车服科技服务有限公司提供，我司需将您的联系方式及车牌号信息告知中保车服科技服务有限公司，以便为您提供更高效、更便捷的服务。本公司已要求前述公司承诺并遵守严格的保密义务及采取有效的保密措施，不会将这些信息用于未经您同意的用途。若有就疑问请咨询我司客服<a
            href="tel:4006995566"
          >（4006995566）</a>或第三方客服<a href="tel:4000026862">（4000026862）</a>。
        </p>
      </div>
    </van-dialog>

    <van-dialog
      v-model="needPushWarning"
      title="提示"
      :show-cancel-button="false"
      confirm-button-text="确定"
    >
      <div class="dialog-wrap">
        <p>
          感谢您选择车辆代为驾驶增值服务，如需此服务请拨打我司人工客服热线<a
            href="tel:95566"
          >95566</a>进行咨询。
        </p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {
  interestsRight,
  userCar,
  getNeedTellCustomer,
  getActiveLink
} from '@/common/api.js';
import { mapActions } from 'vuex';
import Utils from '@/common/util.js';
import { cookieRemove, cookieGet } from '@/common/cookie';
import { e } from 'mathjs';

export default {
  data() {
    return {
      current: 0,
      // carNo: "",
      // vinNo: "",
      loadingBox: true,
      carList: [],
      engineNo: '',
      reportDate: '',
      loadingList: true,
      username: 'gh_3e83e978db70',
      phone: '',
      productTypeMap: {},
      serviceGroups: [],
      isShowTips: true,
      needPushWarning: false, // 是否需要警告
      swiperCurrent: 1,
      discountUrl: '',
      serviceType: '',
      homePage: ''
    };
  },

  computed: {
    // 控制添加按钮的高
    isCanLogin() {
      return this.carList.length < 100;
    },
    isShowGoHomePage() {
      return this.homePage;
    }
  },

  async mounted() {
    // cookieSet('token', "rTSHrzZxg7w90lz7NbVDm95FMxlGaWSkErmv8GCSxMzZNqHbxogg5IByTpr08sLOeJXASegdh73d8UACcX5ujLNAOpUEtNU2tLogYRfbQ7c=", {
    //   domain: '10.0.35.146'
    // })
    // cookieSet('signKey', "1B83F747874EEED6", {
    //   domain: '10.0.35.146'
    // })
    // this.init();
  },
  activated() {
    this.init();
  },

  methods: {
    ...mapActions('wxsdk', ['wxSdkConfig']),

    init() {
      if (this.$route.query.serviceType) {
        this.serviceType = this.$route.query.serviceType;
      }
      if (this.$route.query.homePage) {
        this.homePage = this.$route.query.homePage;
      }
      this.getNeedTellCustomer();
      setTimeout(() => {
        this.loadingBox = false;
      }, 3000);
      this.phone = cookieGet('phone') || '';

      this.checkUserCar();

      // jsapiTicket为请求后台接口
      console.log(this.wxSdkConfig(), 'this.wxSdkConfig()');
      this.wxSdkConfig();

      // 获取中银优惠
      this.getDiscountUrl();
    },
    onChange(index) {
      this.swiperCurrent = index + 1;
      this.current = index;
      const item = this.carList[index];
      this.interestsOn(item);
    },

    addListing() {
      this.$router.push({
        name: 'addListing',
        query: {
          homePage: this.$route.query.homePage || ''
        }
      });
    },

    // 查看用户绑定车辆
    async checkUserCar() {
      const rs = await userCar({});
      this.carList = rs;
      if (this.carList.length > 0) {
        // 有车号，切换到指定的车
        if (this.$route.query.carNo) {
          this.current = this.carList.findIndex(
            (item) => item.carNo === this.$route.query.carNo
          );
          if (this.current === -1) {
            this.current = 0;
          }
        } else {
          this.current = 0;
        }
        this.swiperCurrent = this.current + 1;
        const item = this.carList[this.current];
        this.interestsOn(item);
        if (this.carList.length >= 100) {
          this.loadingList = false;
        } else {
          this.loadingList = true;
        }
      }
    },

    // 权益接口
    async interestsOn(item) {
      try {
        const reportDate = new Date().Format('yyyy-MM-dd hh:mm:ss');
        const rs = await interestsRight({
          carNo: item.carNo,
          vinNo: item.vinNo,
          engineNo: item.engineNo,
          reportDate: reportDate,
          phone: this.phone,
          companyNo: 'BOCI' // 中银的写死的
        });
        if (rs && rs.serviceGroups) {
          let list = rs.serviceGroups;
          if (this.serviceType) {
            list = rs.serviceGroups.filter(
              (item) => item.serviceType === this.serviceType
            );
          }
          list.forEach((gorup, idx) => {
            for (const rightItem of gorup.serviceDetails) {
              rightItem.path = `pages/extend/landing.html?companyNo=BOCI&carNo=${
                item.carNo || ''
              }&vinNo=${item.vinNo || ''}&productType=${
                rightItem.productType
              }&companyBranchNo=${rs.companyBranchNo}&policyNo=${
                rs.policyNo || ''
              }&channelMark=${rightItem.channelMark || ''}&phone=${
                this.phone || ''
              }&rightDateTo=${rightItem.vasExpirationDate || ''}&freeMileage=${
                rightItem.freeMileage || ''
              }&rightDetailId=${
                rightItem.rightDetailId || ''
              }&rightRulePackageBindId=${
                rightItem.rightRulePackageBindId || ''
              }&isSheetSpray=${rightItem.isSheetSpray || ''}`;
              console.log('跳转路径：', rightItem.path);
            }
          });
          this.serviceGroups = list;
        } else {
          this.serviceGroups = [];
        }
      } catch (error) {
        this.serviceGroups = [];
      }
    },
    // 时间戳转为日期格式
    dateTransform(dateTimestamp) {
      if (dateTimestamp) {
        const date = new Date(dateTimestamp);
        return Utils.formatTimestamp(date.getTime(), 'yyyy.MM.dd');
      }
      return '';
    },
    // 获取分类字典数据
    async getNeedTellCustomer() {
      return getNeedTellCustomer()
        .then((res) => {
          const dict = {};
          res.kvs.forEach((item) => {
            dict[item.key] = item.value;
          });
          this.productTypeMap = dict;
          return this.productTypeMap;
        })
        .catch(() => {});
    },
    // 跳转客户条款
    goToUserAgreement(item) {
      this.$router.push({
        path: '/userAgreement',
        query: {
          offset: this.productTypeMap[item.productType],
          path: item.path,
          productType: item.productType,
          serviceType: item.serviceType
        }
      });
    },
    clickTips() {
      this.needPushWarning = true;
    },
    // 编辑车辆信息
    editCarInfo(item) {
      this.$router.push({
        name: 'addListing',
        query: {
          id: item.id,
          homePage: this.$route.query.homePage || ''
        }
      });
    },
    async getDiscountUrl() {
      const rs = await getActiveLink({});
      if (rs) {
        this.discountUrl = rs.url;
      }
    },
    openWindow() {
      window.open(this.discountUrl);
    },
    logout() {
      cookieRemove('token', '');
      this.$router.replace({
        name: 'login',
        query: {}
      });
    },
    goHomePage() {
      const hostname = window.location.hostname;
      console.log('hostname', hostname);
      let url = '';
      //   if (hostname === 'zengzhi.cias.cn') {
      url = `https://che-mobile.bocins.com/#/channel/zhghLogin?channelFlag=zhgh&channelCode=dzsw&code=${this.homePage}`;
      //   } else {
      //     url = `ַhttps://che-mobile-test.bocins.com:9001/#/channel/zhghLogin?channelFlag=zhgh&channelCode=dzsw&code=${this.homePage}`;
      //   }
      console.log(url);
      window.location.replace(url);
    }
  }
};
</script>

<style lang="less" scoped>
.interests-wrap {
  width: 7.5rem;
  height: 100vh;
  font-family: PingFangSC-Regular;
  background: #ffffff;

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 0px;
    flex: 1;

    .box {
      width: 6.9rem;
      height: 2.4rem;
      margin-top: 0.24rem;
      margin-bottom: 0.24rem;

      .interets {
        background: #c0233f;
        width: 6.9rem;
        height: 2.4rem;
        border-radius: 10px;
        position: relative;
        display: flex;

        .tag {
          width: 20%;
          height: 20%;
          position: absolute;
          right: 0.01%;
        }

        .car {
          font-family: PingFangSC-Medium;
          font-size: 20px;
          color: #ffffff;
          letter-spacing: 0;
          font-weight: 500;
          position: absolute;
          top: 24px;
          left: 32px;
        }

        .carNumber {
          opacity: 0.7;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0;
          font-weight: 400;
          position: absolute;
          top: 60px;
          left: 32px;
        }

        .edit_img {
          position: absolute;
          width: 0.32rem;
          height: 0.32rem;
          right: 0.2rem;
          bottom: 0.2rem;
        }

        .num {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          position: absolute;
          bottom: 0.2rem;
          color: #ffffff;
          width: 1rem;
          left: calc((6.9rem - 1rem) / 2);

          .currPage {
            font-size: 10px;
          }
          .total {
            font-size: 10px;
          }
        }
      }
    }

    .discount-box {
      width: 90%;
      .discount-img {
        width: 100%;
      }
    }

    .loading {
      top: 177px;
      width: 40px;
      height: 40px;
    }

    .complete {
      width: 3rem;
      height: 2.8rem;
      margin-top: 1.48rem;

      .imgBig {
        width: 100%;
        height: 100%;
      }

      .carNot {
        font-size: 16px;
        color: #787878;
        letter-spacing: 0;
        text-align: center;
        font-weight: 400;
      }
    }

    .carVip {
      width: 90%;
      font-size: 16px;
      left: 5%;
      display: flex;
      flex-direction: column;
      overflow-y: scroll;
      overflow-x: hidden;
      margin-bottom: 0px;

      &.isCanLogin {
        margin-bottom: 0.96rem;
      }

      .lrc {
        .carTop {
          margin-top: 20px;
          margin-bottom: 12px;
        }

        .listBox {
          height: 78px;
          border-radius: 10px;
          background: #f8e5e8;
          border: 1px solid #be445a;
          display: flex;
          padding: 16px 12px;
          margin-bottom: 12px;

          .boxLeft {
            border-right: 1px dashed #d67788;
            width: 70%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 2px 0px;

            .interests-name {
              font-family: PingFangSC-Regular;
              font-size: 18px;
              color: #383838;
              letter-spacing: 0;
              font-weight: 400;
              line-height: 24px;
              //控制行数
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }

            .interests-data {
              opacity: 0.7;
              font-family: PingFangSC-Regular;
              font-size: 12px;
              color: #383838;
              letter-spacing: 0;
              font-weight: 400;
            }
          }

          .boxRight {
            width: 30%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            text-align: center;
            align-items: center;
            justify-content: center;

            .boxRight-botton {
              width: 80%;
              height: 24px;
              background: #c0233f;
              border-radius: 125pt;
              color: #ffffff;
              font-size: 12px;
              line-height: 25px;
            }
          }
        }
      }

      .lrc::-webkit-scrollbar {
        display: none;
      }
    }

    .button {
      position: fixed;
      bottom: 0%;
      font-size: 16px;
      color: #c0233f;
      width: 7.5rem;
      height: 48px;
      line-height: 48px;
      text-align: center;
      margin-bottom: 0px;
      background: #ffffff;
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: space-around;
    }
  }

  .dialog-wrap {
    padding: 16px;
    font-size: 14px;
    line-height: 20px;
  }

  .go-home {
    position: fixed;
    left: 8px;
    bottom: 72px;
    width: 48px;
    height: 48px;
    .img {
      width: 48px;
      height: 48px;
    }
  }
}
</style>
